import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { UserRole } from 'app/core/authentication';
import { LinkType } from '../models/email-link.model';

import { TOKEN_STORAGE_KEYS } from './token-storage-keys';

@Injectable({
  providedIn: 'root'
})
export class AccessService {
  private userEmail = new BehaviorSubject<string>('');
  private userPassword = new BehaviorSubject<string>('');
  private userRole = new BehaviorSubject<UserRole.student | UserRole.teacher | UserRole.parent | undefined>(undefined);
  private emailType = new BehaviorSubject<LinkType | undefined>(undefined);

  public get email(): string {
    return this.userEmail.value;
  }

  public set email(email: string) {
    this.userEmail.next(email);
  }

  public get password(): string {
    return this.userPassword.value;
  }

  public set password(password: string) {
    this.userPassword.next(password);
  }

  public get role(): UserRole.student | UserRole.teacher | UserRole.parent | undefined {
    return this.userRole.value;
  }

  public set role(role: UserRole.student | UserRole.teacher | UserRole.parent | undefined) {
    this.userRole.next(role);
  }

  public set emailSent(emailType: LinkType | undefined) {
    this.emailType.next(emailType);
  }

  public get emailSent(): LinkType | undefined {
    return this.emailType.value;
  }

  public successfulLogin(): void {
    this.clearInfo();
  }

  public saveInfo(): void {
    const userRole = this.userRole.value;
    if (userRole) {
      localStorage.setItem(TOKEN_STORAGE_KEYS.SELECTED_ROLE, userRole);
    }
  }

  public loadInfo(): void {
    const role = localStorage.getItem(TOKEN_STORAGE_KEYS.SELECTED_ROLE);
    if (role) {
      const userRole = role as UserRole.student | UserRole.teacher | UserRole.parent;
      this.role = userRole;
    }
  }

  private clearInfo(): void {
    this.userRole.next(undefined);
    this.userPassword.next('');
    this.userEmail.next('');
  }
}
